var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17561",
    "data-name": "Group 17561",
    transform: "translate(-803 -574)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    width: 25,
    height: 25,
    transform: "translate(803 574)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "comment",
    d: "M19.621-1.332H3.128A3.128,3.128,0,0,0,0,1.79V11.867a3.128,3.128,0,0,0,3.116,3.122v4.573L9.7,14.99h9.922a3.128,3.128,0,0,0,3.127-3.123V1.79a3.128,3.128,0,0,0-3.127-3.122ZM16.66,10.378H6.089V9.048H16.66Zm0-2.839H6.089V6.209H16.66Zm0-2.839H6.089V3.37H16.66Zm0,0",
    transform: "translate(804 577.332)",
    fill: "#3f2566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.57b7efbf685ee7c73e803e0aa141f16b.svg";
export { ForwardRef as ReactComponent };